import { render, staticRenderFns } from "./mainPre.vue?vue&type=template&id=8a446a0c&scoped=true&"
import script from "./mainPre.vue?vue&type=script&lang=js&"
export * from "./mainPre.vue?vue&type=script&lang=js&"
import style0 from "./mainPre.vue?vue&type=style&index=0&id=8a446a0c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a446a0c",
  null
  
)

/* custom blocks */
import block0 from "./mainPre.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports